import { FC, lazy } from 'react';
import { Successful } from 'src/hooks/use-axios';
import { useTitle } from 'src/hooks/use-title';
import { CurrentShipperUserRequest } from 'src/pages/settings/notifications/use-current-shipper-user';
import { ShipperRequest } from 'src/pages/shipper-admin/details/use-shipper';

const Page = lazy(
  () => import('src/pages/settings/notifications/shipper-edit/page')
);

export const EditShipperNotificationSettings: FC<{
  shipperUser: Successful<CurrentShipperUserRequest>;
  shipper: Successful<ShipperRequest>;
}> = ({ shipperUser, shipper }) => {
  useTitle('Edit Market Notification Settings');
  return <Page shipperUser={shipperUser} shipper={shipper} />;
};
